@if (user !== null) {
  <div class="user-card"
    [ngClass]="{selected: isSelected | async, inactive: !isActive}"
    (click)="onClick()">
    @if (user.isExploit) {
      <div class="user-status"
        >
        <div class="highlighting"
          [ngClass]="user.exploitClass"
        [innerHTML]="user.exploitKey | translate"></div>
      </div>
    }
    @if (!isActive) {
      <div class="user-status"
        >
        <div class="highlighting inactive">{{ 'STATUSES.INACTIVE' | translate }}</div>
      </div>
    }
    <div class="identicon">
      <aa-avatar-icon [src]="user.identiconDataUrl"
        [alt]="user.firstLastName"
        [size]="'48px'">
      </aa-avatar-icon>
    </div>
    <div class="user-actions">
      <div #actions class="action-menu" (click)="actionClick($event)">
        <i class="fas fa-ellipsis-v"></i>
      </div>
    </div>
    <div class="user-impe">
      @if (withImpersonate) {
        <aa-btn-action-secondary
          [size]="'small'"
          [btnText]="'BUTTON.IMPERSONATE.ENTER' | translate"
          (click)="onImpersonate($event)">
        </aa-btn-action-secondary>
      }
    </div>
    <div class="user-details"
      [ngClass]="withRoles ? 'with-roles' : ''">
      <div class="user-name aa-color-primary-normal aa-medium-current-text">{{ user.firstLastName }}</div>
      <div class="user-title aa-light-current-text aa-color-primary-normal">
        {{ user.title !== null ? user.title : ' ' }}
      </div>
      @if (withRoles) {
        <div class="user-roles"
          >
          <aa-icon-appli [appRoles]="appRoles"
            [external]="user.external">
          </aa-icon-appli>
        </div>
      }
      <div class="user-email overflow-ellipsis aa-color-grey-light aa-medium-current-text"
        title="{{ user.email }}">
        <a [href]="mailto">{{ user.email }}</a>
      </div>
      <div class="user-phone overflow-ellipsis aa-color-grey-light aa-medium-current-text"
        title="{{ user.phoneNumber }}">
        <a [href]="telto">{{ user.phoneNumber }}</a>
      </div>
    </div>
  </div>
}
